export default "__VITE_ASSET__CPsNGGld__"